module.exports = __webpack_public_path__ + "img/CWM-WebsiteTiles-EOTAS-F01-IzzyDoll-72dpi.9d949cc6.jpg";